import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../apis/baseQuery';
import { API_CONSTANTS } from '../../utils/constants';
import { ApiResponse, ListResponse } from '../../model';

export interface AutocompleteItem {
    id: number;
    name: string;
}

export const autocompleteApi = createApi({
    reducerPath: 'autocompleteApi',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getDepartmentAutocomplete: builder.query<ListResponse<AutocompleteItem>, any>({
            query: (params) => ({
                url: API_CONSTANTS.AUTOCOMPLETE.DEPARTMENT,
                method: 'GET',
                params,
            }),
        }),
        getSubDepartmentAutocomplete: builder.query<ListResponse<AutocompleteItem>, any>({
            query: (params) => ({
                url: API_CONSTANTS.AUTOCOMPLETE.SUB_DEPARTMENT,
                method: 'GET',
                params,
            }),
        }),
        getDesignationAutocomplete: builder.query<ListResponse<AutocompleteItem>, any>({
            query: (params) => ({
                url: API_CONSTANTS.AUTOCOMPLETE.DESIGNATION,
                method: 'GET',
                params,
            }),
        }),
        getSkillAutocomplete: builder.query<ListResponse<AutocompleteItem>, any>({
            query: (params) => ({
                url: API_CONSTANTS.AUTOCOMPLETE.SKILL,
                method: 'GET',
                params,
            }),
        }),
        getHodAutocomplete: builder.query<ListResponse<AutocompleteItem>, any>({
            query: (params) => ({
                url: API_CONSTANTS.AUTOCOMPLETE.HOD,
                method: 'GET',
                params,
            }),
        }),
    }),
});

export const {
    useGetDepartmentAutocompleteQuery,
    useGetSubDepartmentAutocompleteQuery,
    useGetDesignationAutocompleteQuery,
    useGetSkillAutocompleteQuery,
    useGetHodAutocompleteQuery,
} = autocompleteApi;
